import { Injectable } from '@angular/core';
import { BackendService } from '@toro/common/shared/services/new-http/backend.service';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrderHistoricService {
    public sessionId: string;

    constructor(
        private backendService: BackendService,
        private store: Store<AppState> 
    ) {}

    public getOrders(filteredDate: string): Observable<any[]> {
        try {
            this.fillSessionId();
            return this.backendService.api.get(`/toro-lumen/v1/stock/order/historic?date=${filteredDate}`).pipe(
                map(order => {
                    const keys = Object.keys(order);
                    if (keys.length > 0) {
                        return (order as any)[keys[0]];
                    } else {
                        console.warn('Backend returned an empty object. Returning empty array.');
                        return [];
                    }
                })
            );
        } catch (error) {
            console.error(error);
        }
    }

    private fillSessionId = () => {
        this.store
            .select(({authentication}) => authentication.currentUser)
            .pipe(
                filter((authentication) => !!authentication)
            )
            .subscribe((user) => {
                this.sessionId = user.sessionId
            })
    }
}
